import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee8d5860"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sidebar-item"
}
const _hoisted_2 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_3 = {
  key: 1,
  class: "rel sidebar-item-title"
}
const _hoisted_4 = {
  key: 0,
  class: "abs point-num"
}
const _hoisted_5 = {
  key: 2,
  class: "rel sidebar-item-title",
  style: {"line-height":"1.2"}
}
const _hoisted_6 = {
  key: 0,
  class: "abs point-num"
}
const _hoisted_7 = {
  key: 3,
  class: "rel sidebar-item-title"
}
const _hoisted_8 = {
  key: 0,
  class: "abs point-num"
}
const _hoisted_9 = { class: "tip-content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "rel sidebar-item-title" }
const _hoisted_12 = {
  key: 0,
  class: "abs point-num"
}

import { resolvePath } from '../utils'
import AppLink from '../common/AppLink.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ref, computed, toRaw } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { mainList } from '@/router/modules/user'
import { isD2C, useRtfix, useSite, isKO, isEN } from '@/store'
import { t, lang } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: ['item', 'basePath', 'isNest', 'collapse'],
  setup(__props) {

const props = __props
_useCssVars(_ctx => ({
  "a6eec036": (_unref(sidebarDisplay))
}))


const sidebarDisplay = computed(() => {
  if (props.collapse) {
    return 'none'
  } else {
    return 'block'
  }
})
const store = useStore()
const isSub = store.getters.isSub
// 主账户侧边栏只展示主账户资金明细一栏 子账户只展示店铺资金明细一栏
const showSiderBarItem = (item: any) => isSub ? !item.meta.hidden && !mainList.includes(item.name) : (!item.meta.hidden && !['StoreFund'].includes(item.name))
const showCrossSide = (item:any) => {
  if (item.name === 'CrossSyncProduct' && !store.getters.isCrossMall) {
    return false
  }
  return true
}
const sidebarStyle = () => {
  if (props.collapse) {
    return 'white-space: initial;line-height: 1.2;font-size:14px;'
  }
  return 'white-space: initial;line-height: 1.2;padding-right:25px;font-size:14px; position: relative'
}
// 消息数量
const messageNum = computed(() => {
  return store.getters['message/getMessageNum']
})
const site = computed(() => {
  return store.getters.site
})
// 账单数量
const billNum = computed(() => {
  return store.getters['bill/getBillNum']
})
const notProcessedOrder = computed(() => {
  if (props.item.name === 'AbnormalOrder') {
    return store.getters.notProcessedOrder ?? 0
  } else {
    return 0
  }
})
const myMeasure = computed(() => {
  return store.getters['measure/getMeasureNum']
})

/** 国际发货管理待确认数量 */
const shippingListNum = computed(() => {
  if (['ShippingList', 'ShippingList_d2c'].includes(props.item.name)) {
    return toRaw(store.getters.shippingListNum)
  } else {
    return 0
  }
})
const onlyOneChild: any = ref()
const hasOneShowingChild = (children = [], parent: any): boolean => {
  const realChild = children.filter((i: any) => i?.meta && !i?.meta?.hidden)
  if (realChild.length === 1) {
    onlyOneChild.value = children[0]
    return true
  }

  if (children.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
    return true
  }
  return false
}

const route = useRoute()
const router = useRouter()

const plat = computed(() => store.getters.plat)
// const plat = route.path.split('/')[2]
const pathTitle = (useSite() ? '/' + useSite() : '') + (isD2C() ? '/d2c' : '/b2b')
const setIcon = (icon: string) => {
  const plat = isD2C() ? 'd2c' : 'b2b'
  return icon + '-' + plat
}

// const setIcon = (icon:string) => {
//   const file = icon + '.png'
//   return require('@/assets/image/router/' + file)
// }
const setPath = (val: string) => {
  const basePath = resolvePath(site.value, props.basePath)
  if (val.startsWith('/oem')) {
    return window.location.origin + val
  }
  return resolvePath(basePath, val)
}
const isCheckedChild = (path: any) => route.meta.fpath === path

const warningImg = require('@/assets/image/icon/member/icon_hint@2x.png')
const confirmMember = (child: any) => {
  return () => {
    ElMessageBox.confirm(
      `<img src='${warningImg}' style='position:absolute;top:-38px;height:20px;width:20px'/><p style='white-space:pre-wrap'>${t(child.meta.prompt)}<p>`,
      t('注意3'),
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: t('会员登录'),
        cancelButtonText: t('关闭'),
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: 'sidebarMemberConfirm'
      }
    )
      .then(() => {
        const routerUrl: any = router.resolve(useRtfix('VipLevel'))
        window.open(routerUrl.href, '_black')
      })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (showSiderBarItem(__props.item) && showCrossSide(__props.item))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (hasOneShowingChild(__props.item.children, __props.item) &&
      (!onlyOneChild.value.children || onlyOneChild.value.noShowingChildren) &&
      !__props.item.alwaysShow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (onlyOneChild.value.meta)
                ? (_openBlock(), _createBlock(AppLink, {
                    key: 0,
                    to: setPath(onlyOneChild.value.path)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: onlyOneChild.value.name,
                        style: _normalizeStyle(_unref(isEN)() ? 'white-space: initial;line-height: 1.2;font-size:13px;' : ''),
                        class: _normalizeClass({ 'submenu-title-noDropdown': !__props.isNest, 'checked-child': isCheckedChild(__props.item.path) })
                      }, {
                        title: _withCtx(() => [
                          (__props.item.meta)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (__props.item.meta.icon)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(['router-icon', setIcon(__props.item.meta.icon)])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (onlyOneChild.value.name === 'AbnormalOrder')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                      _createTextVNode(_toDisplayString(onlyOneChild.value.meta.title) + " ", 1),
                                      (_unref(notProcessedOrder).totalOrderCount > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(notProcessedOrder).totalOrderCount > 99 ? '99+' : _unref(notProcessedOrder).totalOrderCount), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (onlyOneChild.value.name === 'ShippingList' || onlyOneChild.value.name === 'ShippingList_d2c')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _createTextVNode(_toDisplayString(onlyOneChild.value.meta.title) + " ", 1),
                                        (_unref(shippingListNum)?.totalCount > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(shippingListNum).totalCount > 99
                    ?
                    '99+' : _unref(shippingListNum).totalCount), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (onlyOneChild.value.name === 'Information')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                          _createTextVNode(_toDisplayString(onlyOneChild.value.meta.title) + " ", 1),
                                          (_unref(messageNum) > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(messageNum) > 99 ? '99+' : _unref(messageNum)), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (onlyOneChild.value.name === 'BillList')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createVNode(_component_el_tooltip, {
                                              placement: "top",
                                              effect: "light",
                                              "raw-content": "",
                                              "popper-class": "bill-tip",
                                              offset: -8
                                            }, {
                                              content: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_9, [
                                                  _createElementVNode("div", {
                                                    class: "tip-text",
                                                    innerHTML: _unref(t)('支払依頼書とは、<br/>システム口座自動引落以外の料金が発生した場合、利用者に対して追加で料金を請求する書類です。<br/>利用者が支払いの請求を承認した時点でシステム残高から料金をお引き落としいたします。<br/>※注意点：発行日から7日以内にお支払いがご確認できない場合、自動で料金をお引き落としさせて頂きます。')
                                                  }, null, 8, _hoisted_10)
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["iconfont icon-wenhao1", __props.collapse && 'abs']),
                                                  style: {"left":"-20px","top":"0","font-size":"14px"}
                                                }, null, 2)
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_11, [
                                              _createTextVNode(_toDisplayString(onlyOneChild.value.meta.title) + " ", 1),
                                              (_unref(billNum) > 0)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(billNum) > 99 ? '99+' : _unref(billNum)), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 64))
                                        : (onlyOneChild.value.name === 'Measure')
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 5,
                                              class: _normalizeClass(["rel sidebar-item-title", _unref(isEN)() ? 'item-line' : ''])
                                            }, [
                                              _createTextVNode(_toDisplayString(onlyOneChild.value.meta.title), 1),
                                              (_unref(myMeasure) > 0)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: _normalizeClass(["abs point-num point-num-item", 'point-num-item ' + _unref(useSite)()])
                                                  }, _toDisplayString(_unref(myMeasure) > 99 ? '99+' : _unref(myMeasure)), 3))
                                                : _createCommentVNode("", true)
                                            ], 2))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                              _createTextVNode(_toDisplayString(onlyOneChild.value.name === 'AuthorizedStore' && _unref(isKO)() ? _unref(t)('子账号配置') : onlyOneChild.value.meta.title), 1)
                                            ], 64))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (__props.collapse)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"20px","height":"20px","padding":"10px","margin-left":"-12px"},
                                class: _normalizeClass(['router-icon', setIcon('workbanch')])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["index", "style", "class"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              ref: (_value, _refs) => {
                _refs['subMenu'] = _value
              },
              index: __props.item.name
            }, {
              title: _withCtx(() => [
                (__props.item.meta)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "flex-center",
                      style: _normalizeStyle(_unref(isEN)() ? sidebarStyle() : '')
                    }, [
                      (__props.item.meta.icon)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['router-icon', setIcon(__props.item.meta.icon), _unref(useSite)()])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      (!__props.collapse)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle([{"flex":"1"}, _unref(isEN)() ? 'font-size:12px;' : ''])
                          }, _toDisplayString(__props.item.meta.title), 5))
                        : _createCommentVNode("", true),
                      (__props.item.meta.name === 'new-calc')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: _normalizeClass(_unref(isEN)() ? 'calc-style-new' : ''),
                            src: "https://static-s.theckb.com/BusinessMarket/icon/new-calc@2.x.png",
                            style: {"width":"41px","margin-left":"4px","height":"16px"}
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
                  return (_openBlock(), _createBlock(memberEventBox, {
                    key: child.path,
                    "stop-propagation": !!child.meta.memberLevel,
                    subscript: false,
                    fn: confirmMember(child),
                    "member-level": child.meta.memberLevel
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_sidebar_item, {
                        "is-nest": true,
                        item: child,
                        "base-path": setPath(child.path),
                        class: "nest-menu"
                      }, null, 8, ["item", "base-path"])
                    ]),
                    _: 2
                  }, 1032, ["stop-propagation", "fn", "member-level"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ]))
    : _createCommentVNode("", true)
}
}

})